import { useState, useEffect } from 'react';
import { Input } from '../../ui/input';
import { Label } from '@radix-ui/react-label';
import Parents from './ParentsBranch';

const Niveau2 = () => {
  const [showParents, setShowParents] = useState(false);
  const [showFamilyTree, setShowFamilyTree] = useState(true);
  const [showData, setShowData] = useState(false);
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [birthPlace, setBirthPlace] = useState(null);
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);
  const isFormComplete = lastName && firstName && email && phoneNumber;
  const [statusStep, setStatusStep] = useState('confirm');
  const [disabled, setDisabled] = useState(true);

  // États d'erreur
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');

  useEffect(() => {
    localStorage.clear();
  }, []);


  const handleChangeFirstName = (e) => {
    setFirstName(e.target.value);
    localStorage.setItem("firstname", e.target.value);
  };

  const handleChangeLastName = (e) => {
    const upperCaseValue = e.target.value.toUpperCase();
    setLastName(upperCaseValue);
    localStorage.setItem("lastname", upperCaseValue);
  };

  const handleChangeEmail = (e) => {
    const value = e.target.value;
    setEmail(value);
    localStorage.setItem("email", value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setEmailError('Email invalide');
    } else {
      setEmailError('');
    }
  };

  const handleChangePhoneNumber = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    localStorage.setItem("phonenumber", value);

    const phoneRegex = /^\+?\d{10,15}$/;
    if (!phoneRegex.test(value)) {
      setPhoneError('Numéro invalide (min. 10 chiffres, chiffres uniquement)');
    } else {
      setPhoneError('');
    }
  };

  // Validation finale pour désactiver le bouton si erreurs
  const isFormValid = isFormComplete && !emailError && !phoneError;

  const exportAndReset = async () => {
    setStatusStep('loading');

    // Reconstituer le tableau des enfants à partir du localStorage
    const children = [];
    let index = 0;
    while (localStorage.getItem(`firstnamechild${index}`)) {
      children.push({
        firstname: localStorage.getItem(`firstnamechild${index}`) || "",
        lastname: localStorage.getItem(`lastnamechild${index}`) || "",
        birthdate: localStorage.getItem(`birthbornchild${index}`) || "", // Assurez-vous d'être cohérent dans les noms
        birthplace: localStorage.getItem(`birthplacechild${index}`) || ""
      });
      index++;
    }

    const data = {
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      birthborn: localStorage.getItem("birthborn"),
      birthplace: localStorage.getItem("birthplace"),
      email: localStorage.getItem("email"),
      phonenumber: localStorage.getItem("phonenumber"),
      postaladdress: localStorage.getItem("postaladdress"),

      firstnamemother: localStorage.getItem("firstnamemother"),
      lastnamemother: localStorage.getItem("lastnamemother"),
      birthbornmother: localStorage.getItem("birthbornmother"),
      birthplacemother: localStorage.getItem("birthplacemother"),

      firstnamefather: localStorage.getItem("firstnamefather"),
      lastnamefather: localStorage.getItem("lastnamefather"),
      birthbornfather: localStorage.getItem("birthbornfather"),
      birthplacefather: localStorage.getItem("birthplacefather"),

      // Informations sur les grands-parents
      firstnamegp1: localStorage.getItem("firstnamegp1"),
      lastnamegp1: localStorage.getItem("lastnamegp1"),
      birthborngp1: localStorage.getItem("birthborngp1"),
      birthplacegp1: localStorage.getItem("birthplacegp1"),

      firstnamegp3: localStorage.getItem("firstnamegp3"),
      lastnamegp3: localStorage.getItem("lastnamegp3"),
      birthborngp3: localStorage.getItem("birthborngp3"),
      birthplacegp3: localStorage.getItem("birthplacegp3"),

      // Informations sur les grands-mères
      firstnamegm2: localStorage.getItem("firstnamegm2"),
      lastnamegm2: localStorage.getItem("lastnamegm2"),
      birthborngm2: localStorage.getItem("birthborngm2"),
      birthplacegm2: localStorage.getItem("birthplacegm2"),

      firstnamegm4: localStorage.getItem("firstnamegm4"),
      lastnamegm4: localStorage.getItem("lastnamegm4"),
      birthborngm4: localStorage.getItem("birthborngm4"),
      birthplacegm4: localStorage.getItem("birthplacegm4"),

      // Informations sur les arrière-grands-pères
      firstnameggp1: localStorage.getItem("firstnameggp1"),
      lastnameggp1: localStorage.getItem("lastnameggp1"),
      birthbornggp1: localStorage.getItem("birthbornggp1"),
      birthplaceggp1: localStorage.getItem("birthplaceggp1"),

      firstnameggp3: localStorage.getItem("firstnameggp3"),
      lastnameggp3: localStorage.getItem("lastnameggp3"),
      birthbornggp3: localStorage.getItem("birthbornggp3"),
      birthplaceggp3: localStorage.getItem("birthplaceggp3"),

      firstnameggp5: localStorage.getItem("firstnameggp5"),
      lastnameggp5: localStorage.getItem("lastnameggp5"),
      birthbornggp5: localStorage.getItem("birthbornggp5"),
      birthplaceggp5: localStorage.getItem("birthplaceggp5"),

      firstnameggp7: localStorage.getItem("firstnameggp7"),
      lastnameggp7: localStorage.getItem("lastnameggp7"),
      birthbornggp7: localStorage.getItem("birthbornggp7"),
      birthplaceggp7: localStorage.getItem("birthplaceggp7"),

      // Informations sur les arrière-grands-mères
      firstnameggm2: localStorage.getItem("firstnameggm2"),
      lastnameggm2: localStorage.getItem("lastnameggm2"),
      birthbornggm2: localStorage.getItem("birthbornggm2"),
      birthplaceggm2: localStorage.getItem("birthplaceggm2"),

      firstnameggm4: localStorage.getItem("firstnameggm4"),
      lastnameggm4: localStorage.getItem("lastnameggm4"),
      birthbornggm4: localStorage.getItem("birthbornggm4"),
      birthplaceggm4: localStorage.getItem("birthplaceggm4"),

      firstnameggm6: localStorage.getItem("firstnameggm6"),
      lastnameggm6: localStorage.getItem("lastnameggm6"),
      birthbornggm6: localStorage.getItem("birthbornggm6"),
      birthplaceggm6: localStorage.getItem("birthplaceggm6"),

      firstnameggm8: localStorage.getItem("firstnameggm8"),
      lastnameggm8: localStorage.getItem("lastnameggm8"),
      birthbornggm8: localStorage.getItem("birthbornggm8"),
      birthplaceggm8: localStorage.getItem("birthplaceggm8"),

      // Données du partenaire
      firstnamepartner: localStorage.getItem("firstnamepartner"),
      lastnamepartner: localStorage.getItem("lastnamepartner"),
      birthbornpartner: localStorage.getItem("birthbornpartner"), // Assure-toi d'utiliser le bon nom
      birthplacepartner: localStorage.getItem("birthplacepartner"),

      // Tableau dynamique des enfants
      children: children
    };

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbzje8yCvT53iRPuimBaw4eSF2JkLfpgGGx1By67ut7nV0MFjvW1mpLqxWzf4L6X0MiUmA/exec", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        mode: 'no-cors', // Important pour éviter les erreurs de CORS
      });
      response.text();

      setStatusStep('success');

      setTimeout(() => {
        // Réinitialisation des états et du localStorage
        localStorage.clear();
        setLastName('');
        setFirstName('');
        setBirthPlace('');
        setEmail('');
        setPhoneNumber('');
        setShowParents(false);
        setShowFamilyTree(true);
        setShowData(false);
        setShowModal(false);
        setStatusStep('confirm');
        setDisabled(true);
      }, 2000);
    } catch (error) {
      setStatusStep('error');
    }
  };

  return (
    <>
      {showData && (
        <div className="w-full p-4 mb-4 text-center font-semibold bg-blue-400 text-white-800">
            Remplissez toutes les parties de ce formulaire pour valider votre arbre et pour envoyer votre arbre cliquez sur le bouton "Envoyer votre arbre" en bas de la page.
        </div>
      )}
      {showParents && (
        <div>
          <Parents setShowData={setShowData} setShowFamilyTree={setShowFamilyTree} setShowParents={setShowParents} />
        </div>
      )}

      {showFamilyTree && (
        <form className="mx-auto max-w-lg">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-800 dark:text-white">
            Créez votre propre arbre généalogique
          </h1>
          <div className='p-10 bg-white dark:bg-black flex items-start justify-center'>
            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Nom <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input id="lastname" value={lastName} onChange={handleChangeLastName} className="w-full max-w-sm" placeholder="Entrez votre nom" required />
              </div>
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Prénom <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input id="firstname" value={firstName} onChange={handleChangeFirstName} className="w-full max-w-sm" placeholder="Entrez votre prénom" required/>
              </div>
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Email <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input
                  type="email"
                  value={email}
                  onChange={handleChangeEmail}
                  className={`w-full max-w-sm ${emailError ? 'border-red-600' : ''}`}
                  id="email"
                  placeholder="Entrez votre email"
                />
                {emailError && <p className="text-red-600 text-sm mt-4 font-bold">{emailError}</p>}
              </div>
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Téléphone <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input
                  type="tel"
                  id="phoneNumber"
                  value={phoneNumber}
                  onChange={handleChangePhoneNumber}
                  className={`w-full max-w-sm ${phoneError ? 'border-red-600' : ''}`}
                  placeholder="Entrez votre téléphone"
                />
                {phoneError && <p className="text-red-600 text-sm mt-4 font-bold">{phoneError}</p>}
              </div>
              {disabled && (
                <div className='mb-4'>
                  <button
                    disabled={!isFormValid}
                    onClick={() => {
                      setShowParents(true);
                      setShowFamilyTree(false);
                      setShowData(true);
                      setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }, 100);
                    }}
                    type="button"
                    className="py-3 px-4 bg-green-100 text-green-800 rounded-lg hover:bg-green-200 disabled:opacity-50"
                  >
                    Suivant
                  </button>
                </div>
              )}
            </div>
          </div>
        </form>
      )}

      {showData && (
        <div className="mx-auto max-w-lg">
          <div className="p-10 bg-white dark:bg-black flex items-start justify-center">
            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
              <p className="text-2xl font-bold text-black dark:text-white">{lastName} {firstName}</p>
              <p className="text-2xl font-bold text-black dark:text-white">{birthPlace}</p>
            </div>
          </div>
            <div className="flex items-center justify-center mt-4">
              <button
                onClick={() => setShowModal(true)}
                type="button"
                className="py-3 px-4 text-2xl bg-green-100 text-green-800 rounded-lg hover:bg-green-200 mb-10"
              >
                Envoyer votre arbre
              </button>
            </div>
        </div>
      )}

      {/* Modale de confirmation */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-gray-700">
          <div className="bg-white dark:bg-neutral-900 p-6 rounded-lg shadow-lg w-96 text-center">
            {statusStep === 'confirm' && (
              <>
                <h2 className="text-xl font-semibold mb-4 dark:text-white text-black">Confirmer l'envoi</h2>
                <p className='dark:text-white text-black mb-6'>Êtes-vous sûr de vouloir envoyer vos données ?</p>
                <div className="flex justify-between">
                  <button
                    onClick={() => setShowModal(false)}
                    className="py-2 px-4 bg-gray-300 rounded-lg hover:bg-gray-400"
                  >
                    Annuler
                  </button>
                  <button
                    onClick={exportAndReset}
                    className="py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    Confirmer
                  </button>
                </div>
              </>
            )}

            {statusStep === 'loading' && (
              <div className="flex flex-col items-center">
                <div className="loader mb-4 border-4 border-blue-500 border-t-transparent rounded-full w-12 h-12 animate-spin" />
                <p className='dark:text-white text-black'>Envoi en cours... <br></br> Veuillez patientez s'il vous plait</p>
              </div>
            )}

            {statusStep === 'success' && (
              <div className="flex flex-col items-center text-green-600">
                <svg className="w-12 h-12 mb-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                <p>Envoi réussi !</p>
              </div>
            )}

            {statusStep === 'error' && (
              <div className="flex flex-col items-center text-red-600">
                <svg className="w-12 h-12 mb-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
                <p>Une erreur est survenue !</p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Niveau2;
